import React from "react";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import DashboardOverviewCard from "../../../../components/PagesComponents/Organizational/Management/Dashboard/OverviewCard.components";
import maintenancesIcon from "../../../../assets/Icons/Pages/Operational/Workshop/Maintenance.svg";
import tendersIcon from "../../../../assets/Icons/Pages/Operational/Workshop/Tenders.svg";
import { Helmet } from "react-helmet";
import ShortLinkCard from "../../../../components/PagesComponents/Organizational/Management/Activities/ShortLinkCard.component";
import SelectFilter from "../../../../components/PagesComponents/UniversalComponents/SelectFilter.component";
import Title from "../../../../components/Universal/Title.component";
import LineChartComponent from "../../../../components/PagesComponents/Financial/Accountant/Dashboard/LineChartGraph.components";
import ScrollableShortCard from "../../../../components/Universal/ScrollableShortCard.component";
import UpcomingEventsCard from "../../../../components/PagesComponents/Organizational/Management/Activities/UpcomingEventsCard.component";
import CardHeader from "../../../../components/Universal/CardHeader.component";
import ScrollableTable from "../../../../components/Universal/Tables/ScrollableTable.component";
import "../../../../styles/Pages/Operational/Workshop/Workshop.style.css";
import SecondModal from "../../../../components/Universal/SecondModal.component";
import FormInput from "../../../../components/Universal/FormInput.component";
import { Form, Formik } from "formik";
import DatePicker from "../../../../components/Universal/DatePicker.component";
const titleToIcon = {
  Maintenance: maintenancesIcon,
  Tenders: tendersIcon,
};

const Body = ({
  overViewCardData,
  workShopBudgetGraphBtn,
  setWorkShopBudgetGraphBtn,
  workshopBudgetGraphData,
  maintenanceHistory,
  tenderHistory,
  maintenanceWorkProgressHistory,
  tendersInProgress,
  addWorkshopModal,
  setAddWorkshopModal,
  addWorkshopFormSelection,
  setAddWorkshopFormSelection,
  maintenanceViewerModal,
  setMaintenanceViewerModal,
  tenderViewerModal,
  setTenderViewerModal,
  // store states
  setMaintenceViewerData,
  maintenanceViewerData,
  setTenderViewerData,
  tenderViewerData,
}) => {
  const lineGraphTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          className="flex-col align-start justify-start back-white radius-6 back-white p-1"
          style={{ border: "1px solid var(--textGray)" }}
        >
          <p className="t-14 poppins color-grayColor">{label}</p>
          <div className="flex-row align-center justify-start g-2">
            <p className="t-20 color-black">
              {payload[0].value.toLocaleString()}
            </p>
            <p className="t-20" style={{ color: "var(--deepGreen3)" }}>
              +31%
            </p>
          </div>
        </div>
      );
    }
    return null;
  };
  console.log(maintenanceViewerData);

  return (
    <div className="workshop-dashboard-body flex-col align-start justify-start pr-1 g-1 pb-1">
      <Helmet>
        <title>Workshop Dashboard | OMS</title>
        <meta name="description" content="Workshop Dashboard | OMS" />
        <meta name="keywords" content="Workshop, Dashboard, OMS" />
      </Helmet>

      {/* add workshop modal  */}
      <SecondModal
        isCrossBtn
        isOpen={addWorkshopModal}
        onClose={setAddWorkshopModal}
      >
        <div className="flex-col align-start justify-start g-2 pt-2 p-1">
          <Title className={"text-align-center"}>Add workshops</Title>

          <div
            className="flex-col align-start justify-start"
            style={{ gap: "22px" }}
          >
            <div className="flex-row align-center justify-start g-1">
              <div className="flex-row align-center justify-start g-05">
                <input
                  type="radio"
                  name="addWorkshop"
                  id="Maintenance"
                  value={"Maintenance"}
                  checked={addWorkshopFormSelection === "Maintenance"}
                  // addWorkshopFormSelection,setAddWorkshopFormSelection
                  className="addWorkshopRadioBtns"
                  onChange={(e) => setAddWorkshopFormSelection(e.target.value)}
                />
                <label htmlFor="Maintenance">Maintenance</label>
              </div>
              <div className="flex-row align-center justify-start g-05">
                <input
                  type="radio"
                  name="addWorkshop"
                  id="Tender"
                  value={"Tender"}
                  className="addWorkshopRadioBtns"
                  checked={addWorkshopFormSelection === "Tender"}
                  onChange={(e) => setAddWorkshopFormSelection(e.target.value)}
                />
                <label htmlFor="Tender">Tender</label>
              </div>
            </div>
            {addWorkshopFormSelection === "Maintenance" ? (
              <Formik
                initialValues={{
                  project: "",
                  budget: "",
                  deadline: "",
                  type: "maintenance",
                }}
                onSubmit={(values) => {
                  console.log(values);
                }}
              >
                {({ errors, setFieldValue, values, touched }) => {
                  return (
                    <Form>
                      <div
                        className="flex-col  align-start justify-start"
                        style={{ gap: "20px" }}
                      >
                        <FormInput
                          name="project"
                          label="Project"
                          type="text"
                          placeholder={"Enter a project name"}
                          errors={errors}
                          touched={touched}
                        />
                        <FormInput
                          name="budget"
                          label="Budget (INR)"
                          type="number"
                          placeholder={"Enter budget amount"}
                          errors={errors}
                          touched={touched}
                        />
                        <DatePicker
                          label={"Deadline"}
                          placeholder={"Choose deadline of project"}
                          name={"deadline"}
                          value={values.deadline}
                          setFieldValue={(val) =>
                            setFieldValue("deadline", val)
                          }
                        />
                        <button type="submit" className="actionBtn w-full p-1">
                          Add workshop
                        </button>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            ) : (
              <Formik
                initialValues={{
                  type: "tender",
                  project: "",
                  budget: "",
                  tender: "",
                  deadline: "",
                }}
                onSubmit={(values) => {
                  console.log(values);
                }}
              >
                {({ errors, setFieldValue, values, touched }) => {
                  return (
                    <Form>
                      <div
                        className="flex-col  align-start justify-start"
                        style={{ gap: "20px" }}
                      >
                        <FormInput
                          name="project"
                          label="Project"
                          type="text"
                          placeholder={"Enter a project name"}
                          errors={errors}
                          touched={touched}
                        />
                        <FormInput
                          name="tender"
                          label="Tender"
                          type="text"
                          placeholder={"Enter tender company"}
                          errors={errors}
                          touched={touched}
                        />
                        <FormInput
                          name="budget"
                          label="Budget (INR)"
                          type="number"
                          placeholder={"Enter budget amount"}
                          errors={errors}
                          touched={touched}
                        />

                        <DatePicker
                          label={"Deadline"}
                          placeholder={"Choose deadline of project"}
                          name={"deadline"}
                          value={values.deadline}
                          setFieldValue={(val) =>
                            setFieldValue("deadline", val)
                          }
                        />
                        <button type="submit" className="actionBtn w-full p-1">
                          Add workshop
                        </button>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            )}
          </div>
        </div>
      </SecondModal>
      {/* view Maintenance history viewer modal */}
      <SecondModal
        isOpen={maintenanceViewerModal}
        onClose={setMaintenanceViewerModal}
        isCrossBtn
      >
        <div className="flex-col align-start justify-start g-2 pt-2 p-1">
          <Title className={"text-align-center"}>Update workshops</Title>

          <div
            className="flex-col align-start justify-start"
            style={{ gap: "22px" }}
          >
            <div className="flex-row align-center justify-start g-1">
              <div className="flex-row align-center justify-start g-05">
                <input
                  type="radio"
                  name=""
                  id="Maintenance"
                  value={"Maintenance"}
                  checked={true}
                  className="addWorkshopRadioBtns"
                />
                <label htmlFor="Maintenance">Maintenance</label>
              </div>
            </div>
          </div>

          <Formik
            enableReinitialize
            initialValues={{
              project: maintenanceViewerData?.project || "",
              budget: maintenanceViewerData?.budget || "",
              deadline: maintenanceViewerData?.deadline || "",
            }}
            onSubmit={(values) => {
              console.log(values);
            }}
          >
            {({ errors, setFieldValue, values, touched }) => {
              return (
                <Form>
                  <div
                    className="flex-col  align-start justify-start"
                    style={{ gap: "20px" }}
                  >
                    <FormInput
                      name="project"
                      label="Project"
                      type="text"
                      placeholder={"Enter a project name"}
                      errors={errors}
                      touched={touched}
                    />
                    <FormInput
                      name="budget"
                      label="Budget (INR)"
                      type="number"
                      placeholder={"Enter budget amount"}
                      errors={errors}
                      touched={touched}
                    />
                    <DatePicker
                      label={"Deadline"}
                      placeholder={"Choose deadline of project"}
                      name={"deadline"}
                      value={values.deadline}
                      setFieldValue={(val) => setFieldValue("deadline", val)}
                    />
                    <button type="submit" className="actionBtn w-full p-1">
                      Add workshop
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </SecondModal>
      {/* view Tender history viewer modal */}
      <SecondModal
        isOpen={tenderViewerModal}
        onClose={setTenderViewerModal}
        isCrossBtn
      >
        <div className="flex-col align-start justify-start g-2 pt-2 p-1">
          <Title className={"text-align-center"}>Update workshops</Title>

          <div
            className="flex-col align-start justify-start"
            style={{ gap: "22px" }}
          >
            <div className="flex-row align-center justify-start g-1">
              <div className="flex-row align-center justify-start g-05">
                <input
                  type="radio"
                  name=""
                  id="Maintenance"
                  value={"Maintenance"}
                  checked={true}
                  className="addWorkshopRadioBtns"
                />
                <label htmlFor="Maintenance">Tender</label>
              </div>
            </div>
          </div>

          <Formik
            enableReinitialize
            initialValues={{
              project: tenderViewerData?.project || "",
              budget: tenderViewerData?.budget || "",
              deadline: tenderViewerData?.deadline || "",
              tender: tenderViewerData?.tender || "",
            }}
            onSubmit={(values) => {
              console.log(values);
            }}
          >
            {({ errors, setFieldValue, values, touched }) => {
              return (
                <Form>
                  <div
                    className="flex-col  align-start justify-start"
                    style={{ gap: "20px" }}
                  >
                    <FormInput
                      name="project"
                      label="Project"
                      type="text"
                      placeholder={"Enter a project name"}
                      errors={errors}
                      touched={touched}
                    />
                    <FormInput
                      name="tender"
                      label="Tender"
                      type="text"
                      placeholder={"Enter tender company"}
                      errors={errors}
                      touched={touched}
                    />
                    <FormInput
                      name="budget"
                      label="Budget (INR)"
                      type="number"
                      placeholder={"Enter budget amount"}
                      errors={errors}
                      touched={touched}
                    />

                    <DatePicker
                      label={"Deadline"}
                      placeholder={"Choose deadline of project"}
                      name={"deadline"}
                      value={values.deadline}
                      setFieldValue={(val) => setFieldValue("deadline", val)}
                    />
                    <button type="submit" className="actionBtn w-full p-1">
                      Add workshop
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </SecondModal>

      <PageHeader />
      <div className="flex-row align-end justify-between">
        <div className="overviewCardContainer">
          {overViewCardData &&
            overViewCardData.map((data, index) => {
              const {
                title,
                presentCount,
                totalCount,
                cardType = "regular",
                bgColor,
              } = data; // Destructure cardType
              const IconComponent = titleToIcon[title];

              return (
                <DashboardOverviewCard
                  key={index}
                  icon={cardType === "regular" ? IconComponent : null} // Condition for icon
                  cardType={cardType} // Pass cardType prop
                  title={title}
                  presentCount={presentCount}
                  totalCount={totalCount}
                  bgColor={bgColor}
                />
              );
            })}
          <ShortLinkCard
            title="Create tender forms"
            description="Via Google forms"
            path="https://docs.google.com"
            cardColor="#889DC0"
          />
        </div>
        <button
          type="button"
          className="actionBtn text-no-wrap"
          onClick={() => setAddWorkshopModal(true)}
        >
          Add workshop
        </button>
      </div>

      <div className="flex-row align-start justify-start g-1 mt-1">
        {/* left */}
        <div className="w-half flex-col align-start justify-start g-1">
          {/* left top */}
          <div
            className="flex-col  justify-start align-start w-full radius-6 g-1 back-white"
            style={{ padding: "1.5rem" }}
          >
            {/* graph header */}
            <div className="flex-row align-center justify-between">
              <Title>Workshop Budget</Title>

              <div className="toggleBtn flex-row align-center justify-start g-05">
                <label htmlFor="total">Total</label>
                <input
                  type="checkbox"
                  name="workshopTotalBudget"
                  id="workshopTotalBudget"
                  checked={workShopBudgetGraphBtn}
                  onChange={(e) => setWorkShopBudgetGraphBtn(e.target.checked)}
                />
              </div>
              <SelectFilter />
            </div>
            {/* line graph */}
            <LineChartComponent
              data={workshopBudgetGraphData}
              customToolTip={lineGraphTooltip}
              lineColor="#ff94d0"
            />
          </div>
          {/* left bottom */}

          <div className="flex-row align-start justify-between g-1 mb-1 flex">
            {/* maintenance history scrollable card component */}
            <div
              className="flex align-start justify-start p-2 back-white w-half radius-13"
              style={{ height: "55vh", padding: "2.5rem" }}
            >
              <ScrollableShortCard
                title={"Maintenance history"}
                actionBtn={
                  <span className="poppins color-greenColor">
                    {maintenanceHistory.length} Projects
                  </span>
                }
              >
                {maintenanceHistory &&
                  maintenanceHistory.map((_data) => (
                    <UpcomingEventsCard
                      key={_data.id}
                      eventName={_data.title}
                      eventDate={_data.vendor}
                      designation={_data.date}
                      handelCardClick={() => {
                        setMaintenanceViewerModal(true);
                        setMaintenceViewerData({
                          project: "Garden grass chopping",
                          budget: "20000",
                          deadline: "23 May, 2025",
                        });
                      }}
                    />
                  ))}
              </ScrollableShortCard>
            </div>
            {/* Tender History scrollable card component */}
            <div
              className="flex align-start justify-start p-2 back-white w-half radius-13"
              style={{ height: "55vh", padding: "2.5rem" }}
            >
              <ScrollableShortCard
                title={"Tender history"}
                actionBtn={
                  <span className="poppins color-greenColor">
                    {tenderHistory.length} Projects
                  </span>
                }
              >
                {tenderHistory &&
                  tenderHistory.map((_data) => (
                    <UpcomingEventsCard
                      key={_data.id}
                      eventName={_data.title}
                      eventDate={_data.vendor}
                      designation={_data.date}
                      handelCardClick={() => {
                        setTenderViewerModal(true);
                        setTenderViewerData({
                          project: "Garden grass chopping",
                          budget: "555556",
                          tender: "Local grass cutter",
                          deadline: "18 May, 2025",
                        });
                      }}
                    />
                  ))}
              </ScrollableShortCard>
            </div>
          </div>
        </div>

        {/* right */}
        <div className="w-half flex-col align-start justify-start g-1">
          {/* right top card table  ===(Maintenance work in progress)===*/}
          <div className="w-full flex-col align-start justify-start g-05 radius-13 back-white p-2 scroll-y">
            <CardHeader
              title="Maintenance work in progress"
              actionBtn={
                <div className="flex-row align-center justify-start g-2">
                  <span className="t-12 poppins color-greenColor">
                    Total: 230000(INR)
                  </span>
                  <span className="t-12 poppins color-greenColor">
                    {maintenanceWorkProgressHistory &&
                      maintenanceWorkProgressHistory.length}{" "}
                    Projects
                  </span>
                </div>
              }
            />

            <div className="flex scroll-y pr-1" style={{ height: "40vh" }}>
              <ScrollableTable
                thead={["Projects", "Budget(INR)", "Deadline"]}
                headerTextColor="var(--grayColor)"
                className={"workshopMaintenanceWorkProgressTable"}
              >
                {maintenanceWorkProgressHistory &&
                  maintenanceWorkProgressHistory.map((_data, index) => {
                    return (
                      <tr key={_data.id}>
                        <td>{_data.name}</td>
                        <td className="color-greenColor">{_data.budget}</td>
                        <td className="color-greenColor">{_data.deadline}</td>
                      </tr>
                    );
                  })}
              </ScrollableTable>
            </div>
          </div>
          {/* right bottom ===(tender word in progress)===  */}
          <div className="w-full flex-col align-start justify-start g-05 radius-13 back-white p-2 scroll-y">
            <CardHeader
              title="Tender work in progress"
              actionBtn={
                <div className="flex-row align-center justify-start g-2">
                  <span className="t-12 poppins color-greenColor">
                    Total: 230000(INR)
                  </span>
                  <span className="t-12 poppins color-greenColor">
                    {tendersInProgress && tendersInProgress.length} Tenders
                  </span>
                </div>
              }
            />

            <div className="flex scroll-y pr-1" style={{ height: "35vh" }}>
              <ScrollableTable
                thead={["Tenders", "Tender for", "Budget & Deadline"]}
                headerTextColor="var(--grayColor)"
                className={"workshopMaintenanceWorkProgressTable"}
              >
                {tendersInProgress &&
                  tendersInProgress.map((_data, index) => {
                    return (
                      <tr key={_data.id}>
                        <td>{_data.contractor}</td>
                        <td className="color-greenColor">
                          {_data.description}
                        </td>
                        <td className="color-greenColor">
                          <div className="flex-col align-end justify-center">
                            <span>{_data.budget}</span>
                            <span>{_data.deadline}</span>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </ScrollableTable>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Body;
